<template>
  <DamagedForm message="Please can you give me a brief description of what's happened?" :required="true"/>
</template>

<script>
import DamagedForm from '../components/DamagedForm'

export default {
  components: {
    DamagedForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DamagedPropertyForm.vue